import axiosInstance from "~/shared/api/axios-instance";

export const deleteCamera = async (params: {
  branchUid: string;
  versionId?: number;
  cameraOrientationId: number;
}) => {
  const { data } = await axiosInstance.delete(
    `branches/${params.branchUid}/pseudo-camera-orientations/${params.cameraOrientationId}/`,
    { params: { version: params.versionId } },
  );
  return data;
};
